import React, { Fragment, useState } from "react"
import { Helmet } from "react-helmet"

//components
import ThemeMenuThree from "../../../components/header/ThemeMenuThree"
import PageTitle from "../../../components/page-title/PageTitle"
import ModalVideos from "../../../components/modal-video/ModalVideos"
import ToolsList from "../../../components/Service/ToolsList"
import Skill from "../../../components/skill/Skill"
import CommonCounter from "../../../components/counter/CommonCounter"
import ServiceCategory from "../../../components/widget/ServiceCategory"
import WidgetForm from "../../../components/form/WidgetForm"
import NewsletterTwo from "../../../components/call-to-action/NewsletterTwo"
import FooterThree from "../../../components/footer/FooterThree"


const ServicesDetails = () => {
    const [open, setOpen] = useState(false);
    const OpenModal = () => {
        setOpen(!open)
    }
    return (
        <Fragment>
            <ModalVideos isOpen={open} onClick={OpenModal} />
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>Desarrollo de Software – Detalle del Servicio</title>
                    <meta name="description" content="Servicio de desarrollo de software de CuySoft. Más de 125 proyectos completados, equipo experto y tecnología de punta para tu empresa en Ecuador." />
                    <meta name="keywords" content="desarrollo de software detalle, proyectos de software, equipo experto, CuySoft Ecuador" />
                    <link rel="canonical" href="https://www.cuysoft.com/services-details" />
                    <meta property="og:title" content="Desarrollo de Software – CuySoft Ecuador" />
                    <meta property="og:description" content="Más de 125 proyectos de software completados. Conoce nuestro servicio de desarrollo a medida." />
                    <meta property="og:url" content="https://www.cuysoft.com/services-details" />
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="Detalles del Servicio" />
                {/* PageTitle */}

                {/*our-services start*/}
                <section className="service-details-wrapper pt-145 pb-100 pt-lg-60 pb-lg-20">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                            <div className="col-lg-12">
                                <div className="service-details-content-top mb-60">
                                    <h2 className="sect-title">Desarrollo de Software</h2>
                                    <p className="text-white mb-35">Integramos rápidamente usuarios centrados en el cliente a través de datos verticales.
                                        Reutilizamos de manera holística
                                        la experiencia interactiva tras recursos distintivos. Diseñamos colaborativamente
                                        imperativos prospectivos con tecnología transparente. Transformamos
                                        excelentes materiales para la colaboración multifuncional y el intercambio de ideas. Innovamos continuamente
                                        en comercio electrónico mantenible sin relaciones a prueba de futuro.</p>
                                    <img className="w-100" src="assets/img/service/img-01.jpg" alt="img" />
                                </div>
                            </div>
                        </div>
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-8">
                                <div className="widget-left-section">
                                    <p className="text-white">Integramos rápidamente usuarios centrados en el cliente a través de datos verticales.
                                        Reutilizamos de manera holística
                                        la experiencia interactiva tras recursos distintivos. Diseñamos colaborativamente
                                        imperativos prospectivos con tecnología transparente. Transformamos
                                        excelentes materiales para la colaboración multifuncional y el intercambio de ideas. Innovamos continuamente
                                        en comercio electrónico mantenible sin relaciones a prueba de futuro.</p>
                                    <p className="text-white mt-15 mb-45">Integramos rápidamente usuarios centrados en el cliente a través de
                                        datos verticales.
                                        Reutilizamos de manera holística
                                        la experiencia interactiva tras recursos distintivos. Diseñamos colaborativamente
                                        imperativos prospectivos con tecnología transparente.</p>
                                    <h3 className="sect-title-two fw-bold mb-20">Nuestra Especialización</h3>
                                    <p className="text-white">Integramos rápidamente usuarios centrados en el cliente a través de datos verticales.
                                        Reutilizamos de manera holística
                                        la experiencia interactiva tras recursos distintivos. Diseñamos colaborativamente
                                        imperativos prospectivos con tecnología transparente.</p>
                                    {/* Skill start */}
                                    <Skill />
                                    {/* Skill end */}
                                    <h3 className="sect-title-two fw-bold mb-20">Nuestras Habilidades</h3>
                                    <p className="text-white">Integramos rápidamente usuarios centrados en el cliente a través de datos verticales.
                                        Reutilizamos de manera holística la experiencia interactiva tras recursos distintivos. Diseñamos colaborativamente
                                        imperativos prospectivos con tecnología transparente. Transformamos
                                        excelentes materiales.</p>
                                    {/* ToolsList */}
                                    <ToolsList />
                                    {/* ToolsList */}
                                    <h3 className="sect-title-two fw-bold mb-20">Brindamos Servicios en los que Puedes Confiar</h3>
                                    <p className="text-white">Integramos rápidamente usuarios centrados en el cliente a través de datos verticales.
                                        Reutilizamos de manera holística la experiencia interactiva tras recursos distintivos. Diseñamos colaborativamente
                                        imperativos prospectivos con tecnología transparente. Transformamos
                                        excelentes materiales.</p>
                                    <div className="service-video d-md-flex mt-40">
                                        <div className="service-single mb-40">
                                            <img className="w-100" src="assets/img/service/img-02.jpg" alt="services-imgs" />
                                        </div>
                                        <div className="service-single-video mb-40">
                                            <img className="w-100" src="assets/img/service/img-03.jpg" alt="services-imgs" />
                                            <a className="popup-video mb-30" onClick={OpenModal} ><i className="bi bi-play-fill" /></a>
                                        </div>
                                        <div className="service-single mb-40">
                                            <img className="w-100" src="assets/img/service/img-04.jpg" alt="services-imgs" />
                                        </div>
                                    </div>
                                    <ul className="text-list list-none">
                                        <li>Diseñamos colaborativamente imperativos prospectivos con tecnología transparente.
                                        </li>
                                        <li>Transformamos excelentes materiales para la colaboración multifuncional
                                            y el intercambio de ideas.</li>
                                        <li>Cultivamos convenientemente procesos convincentes ante redes centradas en el cliente.
                                        </li>
                                    </ul>
                                    <div className="row mt-20">
                                        <div className="col-md-3" data-aos="fade-up">
                                            <div className="counter-style-two boder-style mb-45">
                                                <h3><span className="counter"><CommonCounter value="125" /></span>+</h3>
                                                <p className="text-white mt-20">Desarrollamos Más de 125+ Software</p>
                                            </div>
                                        </div>
                                        <div className="col-md-3" data-aos="fade-up">
                                            <div className="counter-style-two boder-style mb-45">
                                                <h3><span className="counter"><CommonCounter value="64" /></span>+</h3>
                                                <p className="text-white mt-20">Clientes Globales que Confían en Nosotros</p>
                                            </div>
                                        </div>
                                        <div className="col-md-3" data-aos="fade-up">
                                            <div className="counter-style-two boder-style mb-45">
                                                <h3><span className="counter"><CommonCounter value="32" /></span>+</h3>
                                                <p className="text-white mt-20">Premios Locales
                                                    y Globales Ganados</p>
                                            </div>
                                        </div>
                                        <div className="col-md-3" data-aos="fade-up">
                                            <div className="counter-style-two boder-style mb-45">
                                                <h3><span className="counter"><CommonCounter value="122" /></span>+</h3>
                                                <p className="text-white mt-20">Reseñas de Clientes sobre Nuestro Software</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 order-md-first">
                                <div className="widget-right-section mb-40">
                                    {/* ServiceCategory start */}
                                    <ServiceCategory />
                                    {/* ServiceCategory end */}
                                    <div className="widget-form mt-60">
                                        <h3 className="widget-title mb-20">Contáctanos</h3>
                                        <p className="mb-40">Diseñamos colaborativamente imperativos
                                            prospectivos con tecnología transparente.</p>
                                        {/* WidgetForm start */}
                                        <WidgetForm />
                                        {/* WidgetForm end */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*our-services end*/}

                {/*cuysoft-newsletter start*/}
                <NewsletterTwo />
                {/*cuysoft-newsletter end*/}

                {/* FooterThree start */}
                <FooterThree />
                {/* FooterThree end */}

            </div>

        </Fragment>
    )
}

export default ServicesDetails